import * as React from 'react'
import { useMutation } from 'react-query'
import { Toast } from 'antd-mobile'
import { getTextByKey } from '@feedback/utils/util'
import { paramsUploadFile, OSSFile, uploadFile } from '@feedback/services'
import UploadFile from '@feedback/components/UploadFile'
import styles from './index.module.scss'
import { getAppConfig } from '@feedback/utils/CONST'
import clsx from 'clsx'
import { ControllerRenderProps } from 'react-hook-form'
import ModalVideo from '@feedback/components/ModalVideo'

// 上传
export const handleUpdateFiles = async (
  imageList: paramsUploadFile
): Promise<OSSFile> => {
  const res = (await uploadFile(imageList)) || {}
  let msg = getTextByKey('File uploading failed')
  if (res?.code !== 0) {
    if (res?.code === 160001) {
      msg = getTextByKey('File reviewing failed')
      return Promise.reject(new Error(msg))
    }
    msg += res?.message ? ` ${res?.message}` : ''
    return Promise.reject(new Error(msg))
  }
  return res?.data
}

interface IFormItemProps {
  className?: string
  limit?: number
  httpResponse?: (value: any) => void
}

const FormItemVideo: React.FC<IFormItemProps & ControllerRenderProps> = ({
  limit,
  value = [],
  onChange,
  httpResponse
}) => {
  const { appid } = getAppConfig() || {}
  const headerFromApp = JSON.parse(
    sessionStorage.getItem('headerFromApp') || '{}'
  )
  const [openURL, setOpenURL] = React.useState('')

  const uploadFiles = useMutation(handleUpdateFiles, {
    useErrorBoundary: false,
    onSuccess: async (data: any) => {
      if (data?.upload_key && httpResponse) {
        httpResponse(data.upload_key)
      }
    },
    onError: async (err: Error) => {
      let { message } = err || {}
      if (['cm1009', 'cm1017'].includes(appid) && headerFromApp?.language?.includes('fr')) {
        message = getTextByKey('cm1009.fr.File uploading failed')
      }
      Toast.info(`${message}`)
    }
  })

  return (
    <>
      <UploadFile
        multiple
        maxNumber={limit || 3}
        acceptType={[
          'avi',
          'wmv',
          'mpg',
          'mpeg',
          'mov',
          'rm',
          'ram',
          'swf',
          'flv',
          'mp4'
        ]}
        value={value}
        onChange={(files) => {
          if (files.length > 0) {
            uploadFiles.mutate(
              { files: files },
              {
                onSuccess: async () => {
                  onChange(files)
                }
              }
            )
          } else {
            onChange(files)
          }
        }}
        onError={(errors, files) => {
          if (errors?.maxNumber) {
            let msg = getTextByKey('You can only upload a maximum of {limit} files')?.replace('{limit}', limit)
            if (['cm1009', 'cm1017'].includes(appid) && headerFromApp?.language?.includes('fr')) {
              msg = getTextByKey('cm1009.fr.You can only upload a maximum of {limit} files')?.replace('{limit}', limit)
            }
            Toast.info(msg)
          }
          if (errors?.acceptType) {
            let msg = getTextByKey('Please check the file format')
            if (['cm1009', 'cm1017'].includes(appid) && headerFromApp?.language?.includes('fr')) {
              msg = getTextByKey('cm1009.fr.Please check the file format')
            }
            Toast.info(msg)
          }
        }}
      >
        {({ fileList, onFileUpload, onFileRemove }) => (
          <div
            className={clsx(
              styles['form-video-upload'],
              uploadFiles.isLoading && styles.loading,
              styles?.[appid]
            )}
          >
            {fileList.map((file, index) => (
              <div className='item' key={index}>
                <i
                  className='icon-play'
                  onClick={() => {
                    setOpenURL(file?.dataURL as string)
                  }}
                />
                <i
                  className='icon-close'
                  onClick={() => onFileRemove?.(index)}
                />
              </div>
            ))}

            {limit && fileList?.length < limit && (
              <div
                className={`add`}
                onClick={() => {
                  if (!uploadFiles.isLoading) onFileUpload?.()
                }}
              >
                <i className='icon' />
              </div>
            )}
          </div>
        )}
      </UploadFile>

      <ModalVideo
        open={Boolean(openURL)}
        onClose={() => setOpenURL('')}
        url={openURL}
      />
    </>
  )
}

export default FormItemVideo
